<template>
  <div class="h-100">
    <ChatSideBarSetReply
      ref="ChatSideBarSetReply"
      :sendTaggedMessage="sendTaggedMessage"
      @selectedSentReply="selectedSentReply"
    />
    <div
      v-if="isShowChat && !(isNoConversation && conversationId == '')"
      class="d-flex h-100"
    >
      <div v-show="activePanel == 1 || isShowBoth" :class="['panel-list-chat']">
        <div v-if="isNoConversation" class="h-100 border-right">
          <div class="panel-wellcome-chat">
            <div class="text-center">
              <font-awesome-icon :icon="['fas', 'comment-alt']" class="" />
              <p class="mb-0">{{ $t("noChat") }}</p>
            </div>
          </div>
        </div>
        <ChatList
          v-else
          ref="ChatList"
          @select-chat="handleSelectChat"
          @set-show-title="val => $emit('set-show-title', val)"
          :conversationId="conversationId"
          :enableMention="brandSetting?.mentionEnable"
          :enableSla="
            brandSetting?.waitDueIsEnable || brandSetting?.resolutionDueIsEnable
          "
          :updateSurveyUrl="updateSurveyUrl"
          @handle-no-list-chat="val => (isNoConversation = val)"
          @exit-chat-selected="exitChatSelected"
          @handleChangeChatMode="handleChangeChatMode"
          @clearUpdateSurveyUrl="clearUpdateSurveyUrl"
        />
      </div>
      <div
        v-if="activePanel == 2 || activePanel == 3 || isShowBoth"
        :class="['panel-box-chat']"
      >
        <ChatBox
          ref="ChatBox"
          v-if="activePanel == 2 && conversationId != ''"
          :meProfile="meProfile"
          :otherProfile="otherProfile"
          :isFromList="isFromList"
          :isShowBoth="isShowBoth"
          :socialType="socialType"
          :enableMention="brandSetting?.mentionEnable"
          :pendingAutoMycaseEnable="brandSetting?.pendingAutoMycaseEnable"
          :enableEnterToSend="brandSetting?.enterToSendEnable"
          :multipleTopicEnable="brandSetting?.multipleTopicEnable"
          @show-list-chat="
            () => {
              setActivePanel(1);
              conversationId = '';
            }
          "
          @set-show-title="val => $emit('set-show-title', val)"
          @reload-list="$refs.ChatList.getChatList(false)"
          @reload-detail-list="val => $refs.ChatList.reloadDetailList(val)"
          @set-read-conversation="
            val => $refs.ChatList.setReadConversation(val)
          "
          @handle-no-list-chat="val => (isNoConversation = val)"
          @set-selected-user-chat="val => (selectedUserChatInfo = val)"
          :formatIdConversation="conversationId"
          :userId="selectedUserId"
          :channelId="selectedChannelId"
          :class="[isShowBoth ? 'w-65' : 'w-100']"
          :conversationInfo="conversationInfo"
          :userChatInfo="selectedUserChatInfo"
          :conversationTopicsList="conversationTopicsList"
          :chatMode="chatMode"
          @toggleSideBarSetTextReply="val => toggleSideBarSetTextReply(val)"
          @handleConversationTopicsList="handleConversationTopicsList"
          @handleChangeChatMode="handleChangeChatMode"
          @handleSendSurveyUrl="handleSendSurveyUrl"
        />

        <div
          v-if="(activePanel == 2 || isShowBoth) && conversationId == ''"
          class="panel-wellcome-chat"
        >
          <div class="text-center">
            <font-awesome-icon :icon="['fas', 'comment-alt']" class="" />
            <p class="mb-0">{{ $t("welcome") }}</p>
          </div>
        </div>
        <ChatOrderPanel
          v-if="
            (activePanel == 3 || isShowBoth) &&
              selectedUserChatInfo.externalId != '' &&
              selectedUserChatInfo.externalId.length > 0
          "
          class="w-35 border-left"
          :userChatInfo="selectedUserChatInfo"
          :socialType="socialType"
          :chatRoomId="conversationId"
          :isShowBoth="isShowBoth"
          @get-chatlist="$refs.ChatList.reloadDetailList()"
        />
      </div>
    </div>
    <div v-if="isNoConversation && conversationId == ''" class="h-100">
      <div class="panel-wellcome-chat">
        <div class="text-center">
          <font-awesome-icon :icon="['fas', 'comment-alt']" class="" />
          <p class="mb-0">{{ $t("noChat") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatList from "@/components/chat/ChatList";
import ChatBox from "@/components/chat/chatBox/ChatBox";
import ChatOrderPanel from "@/components/chat/chatOrder/ChatOrderPanel";
import ChatSideBarSetReply from "@/components/chat/ChatSideBarSetReply";
import { mapGetters } from "vuex";

export default {
  name: "ChatPanel",
  components: {
    ChatList,
    ChatBox,
    ChatOrderPanel,
    ChatSideBarSetReply
  },
  props: {
    isShowBoth: {
      required: false,
      type: Boolean
    },
    isStateInbox: {
      required: false,
      type: Boolean
    }
  },
  data() {
    return {
      isShowChat: false,
      isFromList: false,
      meProfile: {
        seller: {}
      },
      otherProfile: {
        chatId: ""
      },
      conversationId: "",
      conversationTopicsList: [],
      isNoConversation: false,
      selectedUserId: "",
      selectedUserChatInfo: {
        externalId: ""
      },
      selectedChannelId: "",
      socialType: 0,
      conversationInfo: {},
      sendTaggedMessage: false,
      chatMode: 0,
      updateSurveyUrl: null
    };
  },
  computed: {
    ...mapGetters({
      activePanel: "getActivePanel",
      brandSetting: "getBrandSetting"
    })
  },
  methods: {
    setActivePanel(number) {
      this.$store.dispatch("setActivePanel", number);
    },
    handleChangeChatMode(val) {
      this.chatMode = val;
    },
    handleSelectChat(val) {
      this.$store.commit("UPDATE_CHEACK_CHANGE_CHAT", false);
      if (this.conversationId != val.id) {
        this.conversationTopicsList = [];
        this.isFromList = true;
        this.setActivePanel(2);
        this.conversationId = "";
        this.selectedUserId = "";
        this.selectedChannelId = "";
        this.socialType = 0;
        this.conversationInfo = {};
        this.chatMode = 0;
        this.$store.dispatch("setAgentSelected", true);
        setTimeout(() => {
          this.conversationId = val.id;
          this.selectedUserId = val.userId;
          this.selectedChannelId = val.channelId;
          this.conversationInfo = val;
          this.socialType = val.socialType;
          this.chatMode = val.mode;
          if (this.brandSetting?.multipleTopicEnable) {
            let topicsIds = val.topicsIds;
            if (topicsIds.length < 1) {
              topicsIds = val.lastMessage?.topicsIds?.map(a => a.id) || [];
            }
            this.conversationTopicsList = topicsIds;
          }
        }, 50);
      } else {
        this.setActivePanel(2);
      }
    },
    exitChatSelected() {
      this.setActivePanel(1);
      this.conversationId = "";
      this.selectedUserId = "";
      this.selectedChannelId = "";
      this.socialType = 0;
      this.conversationInfo = {};
      this.selectedUserChatInfo = {
        externalId: ""
      };
    },
    getSomeChatroom() {
      fetch(
        `${this.$chatBaseUrl}/chatroom/chatroom-external?userGUID=${this.$route.query.userGUID}&brandId=${this.$route.query.brandID}&SocialTypeId=${this.$route.query.socialTypeId}`,
        {
          method: "GET",
          headers: new Headers(this.$headersChat)
        }
      )
        .then(response => response.json())
        .then(async result => {
          if (result.result) {
            this.handleSelectChat(result.detail);
            this.isShowChat = true;
            this.isFromList = false;
          }
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    toggleSideBarSetTextReply(taggedMessage) {
      this.sendTaggedMessage = taggedMessage;
      this.$refs.ChatSideBarSetReply.show();
    },
    selectedSentReply(tag) {
      this.$refs.ChatBox.handleConfirmTextReply(tag);
      this.$refs.ChatSideBarSetReply.hide();
    },
    handleConversationTopicsList(val) {
      this.conversationTopicsList = val;
      this.conversationInfo.topicsIds = val;
    },
    handleSendSurveyUrl(url = null, message = null) {
      this.conversationInfo.userSurveyUrl = url;
      this.conversationInfo.userSurveyMessage = message;
      this.updateSurveyUrl = {
        id: this.conversationInfo.id,
        url,
        message
      };
    },
    clearUpdateSurveyUrl() {
      this.updateSurveyUrl = null;
    }
  },
  created() {
    if (
      this.$route.query.isChatBox == "true" &&
      this.$route.query.userGUID &&
      this.$route.query.brandID &&
      this.$route.query.socialTypeId
    ) {
      this.getSomeChatroom();
    } else {
      this.isShowChat = true;
      this.isFromList = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.panel-wellcome-chat {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
  width: 100%;
}
.panel-wellcome-chat svg {
  width: 5rem;
  height: 5rem;
}

.panel-list-chat {
  width: 25%;
}
.panel-box-chat {
  width: 75%;
  height: 100%;
  display: flex;
}
@media (max-width: 1440px) {
  .panel-list-chat {
    width: 30%;
  }
  .panel-box-chat {
    width: 70%;
  }
}
@media (max-width: 1024px) {
  .panel-list-chat {
    width: 50%;
  }
  .panel-box-chat {
    width: 50%;
  }
}
@media (max-width: 767.98px) {
  .panel-list-chat {
    width: 100%;
  }
  .panel-box-chat {
    width: 100%;
    .panel-ChatOrderPanel {
      width: 100% !important;
    }
  }
}
</style>
